export default __webpack_public_path__ + "static/media/unity.b759fc52.svg";